import { useState, useContext } from "react";
import WillEditorInput from "../components/input";
import STKButton from "@/components/common/button";
import STKAnimated from "@/components/common/animated";
import { fieldLabels, viewHeadings, burialPlannerHeadings } from "../will-editor";
import { WillEditorContext } from "../will-editor";
import { PageContentField } from "@/providers/content-provider";

const WillEditorView4 = () => {
    const { will, setWillField, css } = useContext(WillEditorContext);
    const [ editingMode, setEditingMode ] = useState<'FREE_TEXT' | 'GUIDED' | ''>('');

    const activeButtonCSS = {
        backgroundColor: 'var(--color-dark-blue)',
        borderColor: 'var(--color-dark-blue)',
        color: '#FFF'
    }

    return(
        <STKAnimated key={4} type="down-to-up"> 
            <h5>{viewHeadings[3]}</h5>
            <PageContentField section={'view-4'} index={0} />   
            <div className={css.view4__buttons}>
                <STKButton alt style={ editingMode === 'FREE_TEXT' ? activeButtonCSS : {} } onClick={ () => { setEditingMode('FREE_TEXT') } }>
                    Vapaamuotoinen teksti
                </STKButton>
                <STKButton alt style={ editingMode === 'GUIDED' ? activeButtonCSS : {} } onClick={ () => { setEditingMode('GUIDED') } }>
                    Vastaa ohjattuihin kysymyksiin. (Hautajaissuunnitelma)
                </STKButton>
            </div>
            { editingMode !== '' &&
                <>
                    { editingMode == 'FREE_TEXT' ?
                        <STKAnimated key="FREE_TEXT" type="up-to-down">
                            <h6><b>{fieldLabels?.burialInfo__freeText}</b></h6>
                            <WillEditorInput textarea label="Kirjoita tähän vapaasti lisää tietoja hautauksesta." name="burialInfo__freeText" rows={11}></WillEditorInput>
                        </STKAnimated>
                        

                        :
                        <STKAnimated key="GUIDED" type="up-to-down">
                           
                            <h4>Hautajaissuunnitelma</h4>
                            <p>Tässä vaiheessa voit antaa hautajaisia koskevia yksityiskohtaisia tietoja.</p>

                            <h6 className="mt-4 mb-1">1 {burialPlannerHeadings[0]}</h6>
                            <p>{fieldLabels?.burialInfo__coffin}</p>
                            <WillEditorInput textarea label="Kirjoita tähän" name="burialInfo__coffin" rows={3}></WillEditorInput>

                            <h6 className="mt-4 mb-1">2 {burialPlannerHeadings[1]}</h6>
                            <p>{fieldLabels?.burialInfo__stone}</p>
                            <WillEditorInput textarea label="Kirjoita tähän" name="burialInfo__stone" rows={3}></WillEditorInput>

                            <h6 className="mt-4 mb-1">3 {burialPlannerHeadings[2]}</h6>
                            <p>{fieldLabels?.burialInfo__ceremony__where}</p>
                            <WillEditorInput label="Kirjoita tähän" name="burialInfo__ceremony__where"></WillEditorInput>
                            <p className="mt-3">{fieldLabels?.burialInfo__ceremony__how}</p>
                            <WillEditorInput label="Kirjoita tähän" name="burialInfo__ceremony__how"></WillEditorInput>

                            <h6 className="mt-4 mb-1">4 {burialPlannerHeadings[3]}</h6>
                            <p>{fieldLabels?.burialInfo__memorialService__where}</p>
                            <WillEditorInput label="Kirjoita tähän" name="burialInfo__memorialService__where"></WillEditorInput>
                            <p className="mt-3">{fieldLabels?.burialInfo__memorialService__how}</p>
                            <WillEditorInput textarea label="Kirjoita tähän" name="burialInfo__memorialService__how"></WillEditorInput>

                            <h6 className="mt-4 mb-1">5 {burialPlannerHeadings[4]}</h6>
                            <p>{fieldLabels?.burialInfo__obituary}</p>
                            <WillEditorInput label="Kirjoita tähän" name="burialInfo__obituary"></WillEditorInput>

                            <h6 className="mt-4 mb-1">{fieldLabels?.burialInfo__otherWishes}</h6>
                            <WillEditorInput textarea rows={8} label="Kirjoita tähän" name="burialInfo__otherWishes"></WillEditorInput>
                        </STKAnimated>
                    }
                </> 
            }
       
        </STKAnimated>
    );

}

export default WillEditorView4;